import {
  BatchInterceptor
} from "./chunk-UBEFEZXT.mjs";
import {
  decodeBuffer,
  encodeBuffer
} from "./chunk-7II4SWKS.mjs";
import {
  IS_PATCHED_MODULE
} from "./chunk-GFH37L5D.mjs";
import {
  Interceptor,
  InterceptorReadyState,
  deleteGlobalSymbol,
  getGlobalSymbol
} from "./chunk-GM3YBSM3.mjs";

// src/utils/getCleanUrl.ts
function getCleanUrl(url, isAbsolute = true) {
  return [isAbsolute && url.origin, url.pathname].filter(Boolean).join("");
}
export {
  BatchInterceptor,
  IS_PATCHED_MODULE,
  Interceptor,
  InterceptorReadyState,
  decodeBuffer,
  deleteGlobalSymbol,
  encodeBuffer,
  getCleanUrl,
  getGlobalSymbol
};
